// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"cc76afe2","473":"8f77f65e","487":"58a28537","520":"81f51f83","525":"40f5204c","686":"a8556b6e","870":"b2b369e0","895":"8721f337","993":"2467223c"}[chunkId] + ".chunk.css";
};